export const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
export const middleDot = String.fromCharCode(183);
export const BENCHLING_INTEGRATION_META_SLUG = 'benchling-integration-folder-id';
export const DEFAULT_TABLE_WITH_CONTEXT_ROW_HEIGHT = 55;
export const DEFAULT_TABLE_WITH_CONTEXT_MAX_TABLE_HEIGHT = 615;
